export default __webpack_public_path__ + "static/media/bg_special_offers.f9debf49.svg";